import './styles/main.scss'

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import pageTemplatePageClasses from './routes/classes';
import videosLoggedOut from './routes/landing-page';
import videosLoggedIn from './routes/videos-landing';
import singlePost from './routes/post';
import accountLanding from './routes/account';
import singleVideos from './routes/video-single';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  pageTemplatePageClasses,
  singlePost,
  videosLoggedIn,
  videosLoggedOut,
  accountLanding,
  singleVideos
  // contactUs
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());
